export const PaypalIcon = ({
  strokeColor = "var(--color-icon-obscure)",
  ...props
}: any) => (
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
    <path
      d="M47.5 17.5C47.5 17.95 47.475 18.375 47.425 18.8C47.125 22.425 45.525 25.7 43.1 28.1C40.4 30.825 36.65 32.5 32.5 32.5H24.675C23.425 32.5 22.3751 33.425 22.2001 34.65L20.3 47.85C20.15 48.825 19.4501 49.625 18.5251 49.875C18.3001 49.975 18.0751 50 17.8251 50H12.95C11.4 50 10.225 48.625 10.475 47.1L16.45 11.275C17.05 7.64999 20.1751 5 23.8501 5H35C41.9 5 47.5 10.6 47.5 17.5Z"
      fill={strokeColor}
    />
    <path
      opacity="0.4"
      d="M52.4997 27.5008C52.4997 30.9508 51.0997 34.0758 48.8497 36.3508C46.5747 38.6008 43.4497 40.0008 39.9997 40.0008H34.6247C33.3997 40.0008 32.3497 40.8758 32.1497 42.1008L30.3498 52.9008C30.1498 54.1258 29.0997 55.0008 27.8747 55.0008H20.5497C18.9747 55.0008 17.7997 53.5508 18.0997 52.0008L18.5247 49.8758C19.4497 49.6258 20.1497 48.8258 20.2997 47.8508L22.1997 34.6508C22.3747 33.4258 23.4247 32.5008 24.6747 32.5008H32.4997C36.6497 32.5008 40.3997 30.8258 43.0997 28.1008C45.5247 25.7008 47.1247 22.4258 47.4247 18.8008C50.4497 20.5258 52.4997 23.7758 52.4997 27.5008Z"
      fill={strokeColor}
    />
  </svg>
);
